import React,{useState} from 'react';
import Select from 'react-select';
import styled from "styled-components"
import TickIcon from '../../../../assets/imgs/TickIcon.png';
import BBPSlogo from '../../../../assets/imgs/BBPSlogo.svg';
  
const IFSCSelector = ({ liabilitiesIFSCSearch }) => {
    const [isDisabled,setIsDisabled] = useState(false);
    const options = liabilitiesIFSCSearch.map(({bankName,branchhName,ifscCode}) => ({ label: `${bankName} / ${branchhName} / ${ifscCode}`, value:  ifscCode}));
    return(
        <div className="select-container" style={{width: '300px',maxWidth: '100%',opacity:`${isDisabled?0.5:1}`}}>
            <Select options={options} 
                onChange={opt => {window['autosubmit'](opt.value);setIsDisabled(true)}}
                isDisabled = {isDisabled}
            />
        </div>
    );
}

//CreditCard_Rewards

const CreditCardRewards = ({ CreditCard_Rewards }) => {
  
    const handleSelectClick=(sendData)=>{
         let inputString =  sendData + "<split>" + sendData;
         window['autosubmit'](inputString);
    }
 
     return(
         <div>
        {CreditCard_Rewards.map((item,i)=>{
            return(
                 <div className="action-elem" key={i} 
                         onClick={()=>handleSelectClick(item)}
                 
                         >
                         {item}
                 </div>
            )
        })
        } 
        </div>
        
 
        
     );
 }
//CreditCardOrderId


const CreditCardOrderId = ({ creditCardOrderId }) => {

   //console.log(creditCardOrderId[0].order_id)
  
    const handleSelectClick=(sendData)=>{
         let inputString =  sendData + "<split>" + sendData;
         window['autosubmit'](inputString);
    }
 
     return(
         <div>
        {creditCardOrderId.map((item,i)=>{
            return(
                 <div className="action-elem" key={i} 
                         onClick={()=>handleSelectClick(item.order_id)}
                 
                         >
                         {item.order_id}
                 </div>
            )
        })
        } 
        </div>
        
 
        
     );
 }


const BillerRegion = ({ liabilitiesGetBillerCategories }) => {
  
   const handleSelectClick=(sendData)=>{
        let inputString =  sendData + "<split>" + sendData;
        window['autosubmit'](inputString);
   }

    return(
        <div>
       {liabilitiesGetBillerCategories.map((item,i)=>{
           return(
                <div className="action-elem" key={i} 
                        onClick={()=>handleSelectClick(item)}
                        style={{width: "46.5%", display: "inline-block", margin: "5px"}}
                        >
                        {item}
                </div>
           )
       })
       } 
       </div>
       

       
    );
}


const CreditCardBillingCycle = ({ creditCardBillingCycle }) => {
    const [isDisabled, setIsDisabled] = useState(false);
    const options = creditCardBillingCycle.map(({ billingCycle }) => ({ label: billingCycle, value: billingCycle }));

    const handleOnChange = (selected) => {
        const inputString = `${selected}`;
        window['autosubmit'](inputString);
        setIsDisabled(true);
    };

    return (
        <div className="select-container" style={{ width: '300px', maxWidth: '100%', opacity: `${isDisabled ? 0.5 : 1}` }}>
            <Select
                options={options}
                onChange={opt => handleOnChange(opt.value)}
                isDisabled={isDisabled}
                placeholder={'Please select the Billing Cycle'}
            />
        </div>
    );
}

//Nominee Relation*****************************************************************************
const NomineeRelation = ({ NomineeRelationType }) => {
    const [isDisabled,setIsDisabled] = useState(false);
    const options = NomineeRelationType.map(({CD_DESC,CM_CODE}) => ({ label: CD_DESC, value: CM_CODE}));

    const handleOnChange = (selectedCD_DESC, selectedCM_CODE) => {

        let inputString = selectedCD_DESC + "<split>" + selectedCM_CODE;
          window['autosubmit'](inputString);
          setIsDisabled(true);
    
    }
    

    return(
        <div className="select-container" style={{width: '300px',maxWidth: '100%',opacity:`${isDisabled? 0.5: 1}`}}>
            <Select options={options} 
                // onChange={opt => {window['autosubmit'](opt.value);setIsDisabled(true)}}
                onChange={opt => handleOnChange(opt.label,opt.value)}
                isDisabled = {isDisabled}
                placeholder = {'Please select the Relation'}
            />
        </div>
    );
}
// Nominee Country*****************************************************************************
const NomineeCountry = ({ NomineeCountryType }) => {
 
    const [isDisabled,setIsDisabled] = useState(false);
    const options = NomineeCountryType.map(({CD_DESC,CM_CODE}) => ({label: CD_DESC, value: CM_CODE}));

    const handleOnChange = (selectedCD_DESC, selectedCM_CODE) => {

        let inputString = selectedCD_DESC + "<split>" + selectedCM_CODE;
          window['autosubmit'](inputString);
          setIsDisabled(true);
    
    }

    return(
        <div className="select-container" style={{width: '300px',maxWidth: '100%',opacity:`${isDisabled? 0.5: 1}`}}>
            <Select options={options} 
                 onChange={opt => handleOnChange(opt.label,opt.value)}
                isDisabled = {isDisabled}
                placeholder = {'Please select the Country'}
            />
        </div>
    );
}
//Home Loan City```````````````````````
const HomeLoanCity = ({HomeLoanCityNames})=>{
    const [isDisabled,setIsDisabled] = useState(false);
    const options = HomeLoanCityNames.map((item) => ({ label: item.CITY_NAME, value: item.CITY_NAME}));
    const handleOnChange = (selectedSTATE_DESC, selectedSTATE_CODE) => {

        let inputString = selectedSTATE_DESC ;
          window['autosubmit'](inputString);
          setIsDisabled(true);
    
    }
    return(
        <div className="select-container" style={{width: '300px',maxWidth: '100%',opacity:`${isDisabled? 0.5: 1}`}}>
            <Select options={options} 
                  onChange={opt => handleOnChange(opt.label,opt.value)}
                isDisabled = {isDisabled}
                placeholder = {'Please select the City'}
            />
        </div>
    );

}
//Nominee State*****************************************************************************
const NomineeState = ({ NomineeStateType }) => {
    
    const [isDisabled,setIsDisabled] = useState(false);
    const options = NomineeStateType.map((item) => ({ label: item.STATE_DESC, value: item.STATE_CODE}));


    const handleOnChange = (selectedSTATE_DESC, selectedSTATE_CODE) => {

        let inputString = selectedSTATE_DESC + "<split>" + selectedSTATE_CODE;
          window['autosubmit'](inputString);
          setIsDisabled(true);
    
    }


    return(
        <div className="select-container" style={{width: '300px',maxWidth: '100%',opacity:`${isDisabled? 0.5: 1}`}}>
            <Select options={options} 
                  onChange={opt => handleOnChange(opt.label,opt.value)}
                isDisabled = {isDisabled}
                placeholder = {'Please select the State'}
            />
        </div>
    );
}
//Nominee City *****************************************************************************
const NomineeCity = ({ NomineeCityType }) => {
    const [isDisabled,setIsDisabled] = useState(false);
    const options = NomineeCityType.map(({CITY_DESC,CITY_CODE}) => ({ label: CITY_DESC, value: CITY_CODE}));


    const handleOnChange = (selectedCITY_DESC, selectedCITY_CODE) => {

        let inputString = selectedCITY_DESC + "<split>" + selectedCITY_CODE;
          window['autosubmit'](inputString);
          setIsDisabled(true);
    
    }


    return(
        <div className="select-container" style={{width: '300px',maxWidth: '100%',opacity:`${isDisabled? 0.5: 1}`}}>
            <Select options={options} 
                 onChange={opt => handleOnChange(opt.label,opt.value)}
                isDisabled = {isDisabled}
                placeholder = {'Please select the City'}
            />
        </div>
    );
}
// GuardianCode *****************************************************************************
const GuardianCode = ({ liabilitiesFetchDetailsGuardianCode }) => {
    const [isDisabled,setIsDisabled] = useState(false);
    const options = liabilitiesFetchDetailsGuardianCode.map(({CD_DESC,CM_CODE}) => ({label: CD_DESC, value: CM_CODE}));


    const handleOnChange = (selectedCD_DESC, selectedCM_CODE) => {

        let inputString = selectedCD_DESC + "<split>" + selectedCM_CODE;
          window['autosubmit'](inputString);
          setIsDisabled(true);
    
    }

    return(
        <div className="select-container" style={{width: '300px',maxWidth: '100%',opacity:`${isDisabled? 0.5: 1}`}}>
            <Select options={options} 
                 onChange={opt => handleOnChange(opt.label,opt.value)}
                isDisabled = {isDisabled}
                placeholder = {'Please select the Relation'}
            />
        </div>
    );
}
//LeadGenStates & LeadGenCities 
const LeadGenStates = ({ leadGenStates }) => {
    const [isDisabled,setIsDisabled] = useState(false);
    const options = leadGenStates.map(({name}) => ({label: name, value: name}));


    const handleOnChange = (selected_name) => {

        let inputString = selected_name + "<split>" + selected_name;
          window['autosubmit'](inputString);
          setIsDisabled(true);
    
    }

    return(
        <div className="select-container" style={{width: '300px',maxWidth: '100%',opacity:`${isDisabled? 0.5: 1}`}}>
            <Select options={options} 
                 onChange={opt => handleOnChange(opt.label,opt.value)}
                isDisabled = {isDisabled}
                placeholder = {'Please select the State'}
            />
        </div>
    );
}
const LeadGenCities = ({ leadGenCities }) => {
    const [isDisabled,setIsDisabled] = useState(false);
    const options = leadGenCities.map(({name}) => ({label: name, value: name}));


    const handleOnChange = (selected_name) => {

        let inputString = selected_name + "<split>" + selected_name;
          window['autosubmit'](inputString);
          setIsDisabled(true);
    
    }

    return(
        <div className="select-container" style={{width: '300px',maxWidth: '100%',opacity:`${isDisabled? 0.5: 1}`}}>
            <Select options={options} 
                 onChange={opt => handleOnChange(opt.label,opt.value)}
                isDisabled = {isDisabled}
                placeholder = {'Please select the City'}
            />
        </div>
    );
}
//
const Turnover = ({ liabilitiesTurnover }) => {
    const [isDisabled,setIsDisabled] = useState(false);
    const options = liabilitiesTurnover.map((item) => ({label: item, value: item}));
    
    // console.log(options);


    const handleOnChange = (selectedItem) => {

        let inputString = selectedItem + "<split>" + selectedItem;
          window['autosubmit'](inputString);
          setIsDisabled(true);
    
    }

    return(
        <div className="select-container" style={{width: '300px',maxWidth: '100%',opacity:`${isDisabled? 0.5: 1}`}}>
            <Select options={options} 
                 onChange={opt => handleOnChange(opt.label,opt.value)}
                isDisabled = {isDisabled}
                placeholder = {'Please select'}
            />
        </div>
    );
}
//leadGenCountries
const LeadGenCountries = ({ leadGenCountriesISDCodes }) => {
    const [isDisabled,setIsDisabled] = useState(false);
    const options = leadGenCountriesISDCodes.map(({name,code}) => ({label: name+" ("+code+")", value: code}));

    const handleOnChange = (selectedName,selectedCode) => {        
        let backendData = selectedName.slice(0,selectedName.lastIndexOf("(")-1)+","+selectedCode;
        let inputString = selectedName + "<split>" + backendData;
          window['autosubmit'](inputString);
          setIsDisabled(true);
    
    }

    return(
        <div className="select-container" style={{width: '300px',maxWidth: '100%',opacity:`${isDisabled? 0.5: 1}`}}>
            <Select options={options} 
                 onChange={opt => handleOnChange(opt.label,opt.value)}
                isDisabled = {isDisabled}
                placeholder = {'Please select the Country'}
            />
        </div>
    );
}
//

const LocationList = ({ locations }) => {
    const [isDisabled,setIsDisabled] = useState(false);
    const options = locations.map((location) => ({ label: location, value: location}));
    return(
        <div className="select-container" style={{width: '300px',maxWidth: '100%',opacity:`${isDisabled? 0.5: 1}`}}>
            <Select options={options} 
                onChange={opt => {window['autosubmit'](opt.value);setIsDisabled(true)}}
                isDisabled = {isDisabled}
                placeholder = {'Please select the location'}
            />
        </div>
    );
}

//here 

const BillerAccount = ({ liabilitiesGetBillers, DeleteBillerName}) => {
    const [isDisabled,setIsDisabled] = useState(false);
    const options = liabilitiesGetBillers.map(({BillerName,BillerId}) => ({ label: BillerName, value: DeleteBillerName ? BillerName : BillerId}));
    return(
        <div className="select-container" style={{width: '300px',maxWidth: '100%',opacity:`${isDisabled? 0.5: 1}`}}>
           
            <Select options={options} 
                onChange={opt => {window['autosubmit'](opt.value);setIsDisabled(true)}}
                isDisabled = {isDisabled}
                placeholder = {'Please select the biller'}
            />
        </div>
    ); 
}

//here BBPS billers
const BillerName = ({ liabilitiesGetBillers }) => {
    const [isDisabled,setIsDisabled] = useState(false);
 const options = liabilitiesGetBillers.map(({BillerName,BillerId}) => ({ label: BillerName, value: BillerId}));


 const handleOnChange = (selectedBillerName, selectedBillerId) => {

    let inputString = selectedBillerName + "<split>" + selectedBillerId;
      window['autosubmit'](inputString);
      setIsDisabled(true);

}

    return(
        <div className="select-container" style={{width: '300px',maxWidth: '100%',opacity:`${isDisabled? 0.5: 1}`}}>
           
            <Select options={options} 
                onChange={opt => handleOnChange(opt.label,opt.value)}
                isDisabled = {isDisabled}
                placeholder = {'Please select the biller'}
            />
        </div>
    );
}


const BillPaymentSummary = (props) => {

    const {BbpsFlag} = props; 
   const {makeBillPayment} = props; 

//    const makeBillPayment = something;//For testing -> remove this
//     console.log(makeBillPayment);


        const showBillerSummary = ()=>{
    
            return [makeBillPayment].map((item,i)=>{
                return(
                    <PaymentDetail key={i}>
                        <PaymentLogo>
                            <img src={TickIcon}></img>
                        </PaymentLogo>
                        <PaymentTitle>
                            Payment Successful !
                        </PaymentTitle>
                        <PaymentSubTitle>
                            Thank you for the payment
                        </PaymentSubTitle>

                        <DashBorder/>
      
                           {
                           BbpsFlag?  
                           <BillerRow>
                            <BillerLabel>Payment Details:</BillerLabel>
                            <BillerValue><img style={{height:'36px'}}src={BBPSlogo}></img></BillerValue>
                           </BillerRow>
                           :null
                           }
                   

                        <BillerRow>
                           <BillerLabel>Biller Name:</BillerLabel>
                           <BillerValue>{item.biller_name}</BillerValue>
                        </BillerRow>

                        <BillerRow>
                           <BillerLabel>Status:</BillerLabel>
                           <BillerValue>{item.payment_status}</BillerValue>
                        </BillerRow>

                        <BillerRow>
                           <BillerLabel>{item.Authenticators[0].ParameterName}</BillerLabel> 
                           <BillerValue>{item.Authenticators[0].Value}</BillerValue>
                        </BillerRow>
                        
                        {BbpsFlag? 
                          item.bbps_ref_no!=undefined?
                          <BillerRow>
                            <BillerLabel>BBPS Ref No.:</BillerLabel>
                            <BillerValue>{item.bbps_ref_no}</BillerValue>
                          </BillerRow>:null
                        :
                        null
                        
                        }
                        <BillerRow>
                           <BillerLabel>Transaction ID:</BillerLabel>
                           <BillerValue>{item.paymentid}</BillerValue>
                        </BillerRow>

                        <BillerRow>
                           <BillerLabel>Bill Amount:</BillerLabel>
                           <BillerValue>{item.payment_amount}</BillerValue>
                        </BillerRow>

                        <BillerRow>
                           <BillerLabel>Convenience Fees:</BillerLabel>
                           <BillerValue>{item.cou_conv_fee}</BillerValue>
                        </BillerRow>

                        {/* <BillerRow>
                           <BillerLabel>Total Amount:</BillerLabel>
                           <BillerValue>{item.debit_amount}</BillerValue>
                        </BillerRow> */}

                        <BillerRow>
                           <BillerLabel>Transaction Date:</BillerLabel>
                           <BillerValue>{item.txn_date}</BillerValue>
                        </BillerRow>

                        <BillerRow>
                           <BillerLabel>Transaction Time:</BillerLabel>
                           <BillerValue>{item.txn_time}</BillerValue>
                        </BillerRow>


                    </PaymentDetail>
                )
            });
        }
        return (
            <React.Fragment>
                {showBillerSummary()}
            </React.Fragment>
        );
    };
    
    
const PaymentDetail = styled.div`
    min-width:280px;
    margin-top : 2px;
`
const PaymentLogo =styled.div`
    text-align: center;
    width: 40px;
    height: 40px;
    margin: 10px auto;
    img{
        width:100%;

    }
    
`
const PaymentTitle = styled.div`
    color:green;
    font-weight:600;
    font-size:18px;
    text-align: center;
`
const PaymentSubTitle = styled.div`
    color: #666666;
    font-size:12px;
    text-align: center;
`
const DashBorder = styled.div`
    margin-top:20px;
    margin-bottom:16px;
    border: 0.4px dashed #666666; 
`

const BillerRow =styled.div`
    font-size:12px;
    padding: 8px 0px;
    border-bottom:1px solid rgba(0,0,0,0.03);
`

const BillerLabel = styled.div`
    display: inline-block;
    vertical-align:middle;
    width:40%;
    color: #666666;
    text-align: left;
    margin:0px;
`
const BillerValue = styled.div`
    display: inline-block; 
    vertical-align:middle; 
    width:60%;
    color: #666666;
    text-align: right;
    font-weight:550;
    margin:0px;
   
`

export default IFSCSelector;
 
export {BillerRegion,BillerName,LocationList,BillerAccount,BillPaymentSummary,CreditCardBillingCycle,NomineeRelation,NomineeCountry,NomineeState,NomineeCity,GuardianCode,LeadGenStates,LeadGenCities,Turnover,LeadGenCountries,CreditCardRewards,CreditCardOrderId,HomeLoanCity};
